
import React, { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Mail } from "lucide-react";
import ReactGA from "react-ga4";

const Support: React.FC = () => {
  useEffect(() => {
    // Track support page view
    ReactGA.event({
      category: "Support",
      action: "View Support Page",
    });
  }, []);

  const handleEmailClick = () => {
    window.location.href = "mailto:eatsboosthelp@gmail.com";
    ReactGA.event({
      category: "Support",
      action: "Click Email",
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container max-w-4xl mx-auto px-4 py-12">
        <div className="mb-8 text-center">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">
            EatsBoost Support
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Need help with EatsBoost? Our support team is ready to assist you.
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-md p-6 md:p-8 max-w-2xl mx-auto">
          <div className="space-y-8">
            {/* Email Support Section */}
            <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
              <div className="flex-shrink-0 bg-amber-100 p-3 rounded-full">
                <Mail className="h-6 w-6 text-amber-600" />
              </div>
              <div className="flex-grow">
                <h3 className="text-lg font-semibold">Email Support</h3>
                <p className="text-gray-600 mb-3">
                  Send us an email for any inquiries or issues.
                </p>
                <Button
                  variant="outline"
                  className="border-amber-500 text-amber-600 hover:bg-amber-50"
                  onClick={handleEmailClick}
                >
                  eatsboosthelp@gmail.com
                </Button>
              </div>
            </div>

            {/* Contact Information Tips */}
            <div className="bg-blue-50 p-4 rounded-md border border-blue-100">
              <h3 className="text-md font-medium text-blue-800 mb-2">For faster response times:</h3>
              <p className="text-sm text-blue-700">
                Please include the following information in your support request:
              </p>
              <ul className="text-sm text-blue-700 list-disc ml-5 mt-2">
                <li>Your first name</li>
                <li>Your last name</li>
                <li>Your phone number</li>
              </ul>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200 text-center">
            <p className="text-sm text-gray-500">
              Please allow up to 2 business days for a response from our support team.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;
